import React, { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import initLDDebugTools from './debug';

/**
 * Component that initializes and exposes the LaunchDarkly client
 * This component doesn't render anything visible
 */
const LDClientInitializer = () => {
  const client = useLDClient();

  useEffect(() => {
    if (typeof window !== 'undefined' && client) {
      // Expose the client to the window object
      window.ldClient = client;
      
      // Create a wrapper to hold the client
      window.LD_WRAPPER = window.LD_WRAPPER || {};
      window.LD_WRAPPER.client = client;
      
      console.log('LaunchDarkly client exposed as window.ldClient from LDClientInitializer');
      
      // Initialize debug tools
      initLDDebugTools();
      
      // Also expose the initialization function
      window.initLDDebugTools = initLDDebugTools;
    }
  }, [client]);

  // This component doesn't render anything
  return null;
};

export default LDClientInitializer;
